


<div class="">

    <div class="uk-container uk-margin-medium-bottom uk-text-center " uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">
        <h1 class="uk-margin-medium-top titile" ><b>Serviço com suporte local 24/7</b>
        </h1>
        <p>Os nossos técnicos estão disponíveis 24 horas, 7 dias por semana para ajudar</p>
    </div>
    
    
    
    <div class="uk-container uk-margin-medium-top ">
        <div class="uk-child-width-1-3@l uk-child-width-1-1@s uk-grid-match uk-grid uk-text-center" uk-grid uk-scrollspy="cls: uk-animation-slide-bottom-small; target: > div; delay: 200">
            
            <div>
                <div class="uk-card fundo-luanda uk-border-rounded uk-card-hover uk-card-body uk-flex uk-flex-column">
                    <h3 class="uk-card-title" style="color: white;"><b>Luanda</b>, Angola</h3>
                    <p style="color: white;">Se você está procurando por uma empresa que possa atender às suas necessidades em Luanda, por favor entre em contacto conosco. Estamos ansiosos para discutir como podemos ajudá-lo a alcançar seus objectivos.</p>
                    <div class="card-footer">
                        <a href="https://wa.me/244937754502/?text=Ol%C3%A1%2C%20estou%20interessado%20em%20servi%C3%A7o%20vosso%2C%20h%C3%A1%20algu%C3%A9m%20dispon%C3%ADvel%20agora%20para%20me%20atender%3F" target="_blank" class="uk-button market-contact-btn">Fale conosco</a>
                    </div>
                </div>
            </div>
            <div>
                <div class="uk-card fundo-kinshasa uk-border-rounded uk-card-hover uk-card-body uk-flex uk-flex-column">
                    <h3  class="uk-card-title" style="color: white;"><b>Kinshasa</b>, RDC</h3>
                    <p style="color: white;">Kinshasa é uma cidade em crescimento e oferece muitas oportunidades de negócios. Nossa presença na região nos permite aproveitar essas oportunidades e oferecer serviços de alta qualidade aos nossos clientes.</p>
                    <div class="card-footer">
                        <a href="https://wa.me/244937754502/?text=Bonjour%2C%20je%20suis%20int%C3%A9ress%C3%A9(e)%20par%20vos%20services.%20Y%20a-t-il%20quelqu%E2%80%99un%20de%20disponible%20pour%20m%E2%80%99aider%20en%20ce%20moment%20%3F" target="_blank" class="uk-button market-contact-btn">Parlez avec un spécialiste.</a>
                    </div>
                </div>
            </div>
            <div>
                <div class="uk-card fundo-madeira uk-border-rounded uk-card-hover uk-card-body uk-flex uk-flex-column">
                    <h3 class="uk-card-title" style="color: white;"><b> Madeira</b>, Portugal</h3>
                    <p style="color: white;">Estamos próximos ao mercado europeu e temos acesso a uma infraestrutura de transporte e logística de ponta, o que nos permite oferecer serviços de alta qualidade e rapidez aos nossos clientes.</p>
                    <div class="card-footer">
                        <a href="https://wa.me/244937754502/?text=Ol%C3%A1%2C%20estou%20interessado%20em%20servi%C3%A7o%20vosso%2C%20h%C3%A1%20algu%C3%A9m%20dispon%C3%ADvel%20agora%20para%20me%20atender%3F" target="_blank" class="uk-button market-contact-btn">Fale conosco</a>
                    </div>
                </div>
            </div>

        </div>
    </div>


    <div class="uk-container uk-text-center uk-padding" uk-scrollspy="cls: uk-animation-scale-up; delay: 300">
        <!-- Botão "Área de Cliente" -->
        <a href="https://q28hpkmheelk.upmind.app/login" target="_blank" class="client-area-btn">Área de Cliente</a>
    </div>

</div>


